(function () {
  class SlCampaignTopSale extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.slider = this.querySelector('[data-sl-top-sale-slider]');
      this.nextButton = this.querySelector('[data-sl-top-sale-next]');
      this.prevButton = this.querySelector('[data-sl-top-sale-prev]');
      this.progressFill = this.querySelector('[data-sl-top-sale-progress-fill]');
      this.boundUpdateProgress = this.updateProgress.bind(this);

      this.initSwiper();
      window.addEventListener('resize', this.boundUpdateProgress);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundUpdateProgress);
      this.swiper?.destroy?.(true, true);
    }

    initSwiper() {
      if (!this.slider || typeof window.Swiper === 'undefined') return;

      this.swiper = new window.Swiper(this.slider, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 600,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation:
          this.nextButton && this.prevButton
            ? {
                nextEl: this.nextButton,
                prevEl: this.prevButton,
              }
            : false,
        breakpoints: {
          768: {
            spaceBetween: 16,
          },
          1200: {
            spaceBetween: 18,
          },
        },
        on: {
          init: () => this.updateProgress(),
          resize: () => this.updateProgress(),
          setTranslate: () => this.updateProgress(),
          transitionEnd: () => this.updateProgress(),
          slideChange: () => this.updateProgress(),
        },
      });
    }

    updateProgress() {
      const track = this.querySelector('.sl-campaign-top-sale__progress');
      if (!this.progressFill || !track || !this.swiper) return;

      const snapCount = this.swiper.snapGrid?.length || 0;
      if (snapCount <= 1) {
        this.progressFill.style.width = '100%';
        this.progressFill.style.transform = 'translateX(0px)';
        return;
      }

      const visibleRatio = Math.min(1, this.swiper.width / this.swiper.virtualSize);
      const trackWidth = track.clientWidth || 100;
      const thumbWidthPx = Math.max(24, visibleRatio * trackWidth);
      const minTranslate = this.swiper.minTranslate ? this.swiper.minTranslate() : 0;
      const maxTranslate = this.swiper.maxTranslate ? this.swiper.maxTranslate() : 0;
      const translateRange = minTranslate - maxTranslate;
      let progress = 0;

      if (translateRange > 0) {
        progress = (minTranslate - this.swiper.translate) / translateRange;
      }

      progress = Math.min(1, Math.max(0, progress));
      const travelPx = Math.max(0, trackWidth - thumbWidthPx);

      this.progressFill.style.width = `${thumbWidthPx}px`;
      this.progressFill.style.transform = `translateX(${travelPx * progress}px)`;
    }
  }

  if (!customElements.get('sl-campaign-top-sale')) {
    customElements.define('sl-campaign-top-sale', SlCampaignTopSale);
  }
})();
